module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<nav class='pagination-controls'>\n  <ul class='pagination'>\n    <li class='page-item' v-bind:class=\"{ 'disabled': currentPage <= 1 }\">\n      <a class='page-link' v-on:click='goToPage(currentPage - 1)' href='#'>\n        {{ t('previous_page') }}\n      </a>\n    </li>\n    <li class='page-item' v-bind:class=\"{ 'disabled': currentPage >= totalPages }\">\n      <a class='page-link' v-on:click='goToPage(currentPage + 1)' href='#'>\n        {{ t('next_page') }}\n      </a>\n    </li>\n  </ul>\n</nav>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
